import { Avatar } from '../avatar';

/**
 * Mismo avatar que la lista de participantes (borde índigo + iniciales).
 */
export function MentionAvatar({ user, initials, size = 'md', className = '' }) {
    return (
        <Avatar
            firstName={user?.firstName}
            lastName={user?.lastName}
            initials={initials}
            size={size}
            className={className}
        />
    );
}
